import { VStack } from "native-base";

export default VStack;